import {Box, Typography} from "@mui/material";
import LoadingScreen from "components/ScreenState/Loading";
import {useConfigs} from "context/ConfigsContext";
import type {FC} from "react";

const PaybillOptions: FC = () => {
  const {configs, loading, error} = useConfigs();

  const paybillConfig = configs?.mpesa;

  return (
    <>
      {loading && <LoadingScreen />}

      {paybillConfig && (
        <Box>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            Or top up via M-PESA Paybill
          </Typography>

          {[
            "Go to M-Pesa menu",
            {text: "Enter Business Number: ", value: paybillConfig.paybill},
            {
              text: "Enter Account Number: ",
              value: paybillConfig.account_number,
            },
            "Enter Amount e.g 10,000",
            "Enter your M-Pesa Pin and click Send",
          ].map((step, index) => (
            <Typography key={index} variant="body2">
              <strong>{index + 1}: </strong>{" "}
              {typeof step === "string" ? (
                step
              ) : (
                <>
                  {step.text}
                  <strong>{step.value}</strong>
                </>
              )}
            </Typography>
          ))}

          <Typography variant="caption" color="text.secondary">
            Send the desired amount to the Paybill above. Units will reflect
            once payment is confirmed.
          </Typography>
        </Box>
      )}

      {error && (
        <Typography color="error" variant="caption">
          Failed to load Paybill configuration.
        </Typography>
      )}
    </>
  );
};

export default PaybillOptions;
